// YouTube links, as editors paste them: watch?v=, youtu.be/, embed/ or shorts/.
const YOUTUBE = /^https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/;

// The video's 11-character id, or null for anything that isn't a YouTube link.
export function youtubeId(url) {
  const m = String(url || '').match(YOUTUBE);
  return m ? m[1] : null;
}

// YouTube's privacy-enhanced (no-cookie) player for the video.
export function embedUrl(id, autoplay = false) {
  return `https://www.youtube-nocookie.com/embed/${id}${autoplay ? '?autoplay=1' : ''}`;
}
